import * as user from './user/actions';
import * as route from './route/actions';

export default { user, route };
